<script>
  // Bind `value` to an ISO date string (YYYY-MM-DD) or ''.
  // Usage:
  //   <DatePicker bind:value={dateIso} />
  //   <DatePicker bind:value={dateIso} max={todayIso} clearable />
  export let value     = '';
  export let max       = '';       // ISO date string — omit for no upper bound
  export let clearable = false;    // show ✕ button when a date is set

  let input;
  function open() { input?.showPicker?.(); input?.click(); }
</script>

<div class="date-wrap">
  <input
    type="date"
    bind:this={input}
    bind:value
    max={max || undefined}
    class="date-hidden"
    tabindex="-1"
  />
  <button type="button" class="date-display" class:set={!!value} on:click={open}>
    {#if value}
      {@const [y, m, d] = value.split('-')}
      <span class="date-seg">{d}</span><span class="date-dot">·</span>
      <span class="date-seg">{m}</span><span class="date-dot">·</span>
      <span class="date-seg date-seg-yr">{y}</span>
    {:else}
      <span class="date-placeholder">dd · mm · yyyy</span>
    {/if}
    <svg class="date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  </button>
  {#if clearable && value}
    <button type="button" class="date-clear" on:click={() => value = ''}>✕</button>
  {/if}
</div>

<style>
  .date-wrap     { position: relative; display: flex; align-items: center; gap: 0.4rem; }
  .date-hidden   { position: absolute; opacity: 0; pointer-events: none; width: 1px; height: 1px; }
  .date-display  {
    display: flex; align-items: center; gap: 0.4rem; flex: 1;
    background: #0a0a0a; border: 1px solid #1e3d00; border-radius: 2px;
    padding: 0.55rem 0.75rem; cursor: pointer;
    font-family: 'Rajdhani', sans-serif; font-weight: 600;
    transition: border-color 0.2s;
  }
  .date-display:hover, .date-display.set { border-color: #3a6b00; }
  .date-seg      { font-size: 1rem; color: #6db800; }
  .date-seg-yr   { color: #c8c8c8; }
  .date-dot      { color: #3a6b00; font-size: 0.9rem; }
  .date-placeholder { font-size: 0.85rem; color: #2a5200; letter-spacing: 0.08em; }
  .date-icon     { width: 15px; height: 15px; stroke: #3a6b00; margin-left: auto; flex-shrink: 0; }
  .date-clear    {
    background: none; border: none; color: #2a5200; cursor: pointer;
    font-size: 0.7rem; padding: 0.25rem; line-height: 1; transition: color 0.15s;
  }
  .date-clear:hover { color: #cc4400; }
</style>
